/*
==========================================
Custom JS for Designer article
==========================================
*/

// スクロールイン
const scrollIn = () => {
  // const fadeInImages = document.querySelectorAll(".c-designer-work__image");
  const fadeInImages = document.querySelectorAll(".c-designer-work__row > *");
  for (var i = 0; i < fadeInImages.length; i++) {
    var elemPos = fadeInImages[i].offsetTop,
        scroll = window.pageYOffset || document.documentElement.scrollTop,
        windowHeight = window.innerHeight;
    if (scroll > elemPos - windowHeight + (windowHeight * 0.45)) {
      fadeInImages[i].classList.add("scroll-in");
    }
  }
}
window.addEventListener("load", scrollIn);
window.addEventListener("scroll", scrollIn);
